import * as React from "react";
import {splitDirection} from '../domain/FeaturesState';

interface ToggleSplitscreenButtonProps {
    onToggleSplitscreen: () => void,
    splitDirection: splitDirection
}
export class ToggleSplitscreenButton extends React.Component<ToggleSplitscreenButtonProps, {}>{
    render() {
        const isHorizontal = this.props.splitDirection == 'horizontal';
        const direction = isHorizontal ? 'vertical' : 'horizontal';
        const title = isHorizontal ? 'Vis vertikaldelt' : 'Vis horisontaldelt';
        return (<div className={`splitScreenToggle glyphicon glyphicon-resize-${direction}`}
                     title={title}
                     onClick={() => this.props.onToggleSplitscreen()} />);
    }
}
